module.exports = __webpack_public_path__ + "static/img/unionpay.7c782f3d.png";